/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ProductListSkuProductItem } from './ProductListSkuProductItem';
import {
    ProductListSkuProductItemFromJSON,
    ProductListSkuProductItemFromJSONTyped,
    ProductListSkuProductItemToJSON,
    ProductListSkuProductItemToJSONTyped,
} from './ProductListSkuProductItem';
import type { ProductListBarcodeItem } from './ProductListBarcodeItem';
import {
    ProductListBarcodeItemFromJSON,
    ProductListBarcodeItemFromJSONTyped,
    ProductListBarcodeItemToJSON,
    ProductListBarcodeItemToJSONTyped,
} from './ProductListBarcodeItem';

/**
 * 
 * @export
 * @interface ProductListSkuItem
 */
export interface ProductListSkuItem {
    /**
     * SKU主键ID
     * @type {number}
     * @memberof ProductListSkuItem
     */
    skuId?: number;
    /**
     * SKU编码
     * @type {string}
     * @memberof ProductListSkuItem
     */
    skuCode?: string;
    /**
     * SKU图片URL
     * @type {string}
     * @memberof ProductListSkuItem
     */
    imageUrl?: string;
    /**
     * 
     * @type {Array<ProductListBarcodeItem>}
     * @memberof ProductListSkuItem
     */
    barcodes?: Array<ProductListBarcodeItem>;
    /**
     * 单价
     * @type {number}
     * @memberof ProductListSkuItem
     */
    unitPrice?: number;
    /**
     * 重量（kg）
     * @type {number}
     * @memberof ProductListSkuItem
     */
    wtKg?: number;
    /**
     * 包装规格（长*宽*高 cm）
     * @type {string}
     * @memberof ProductListSkuItem
     */
    packageSpec?: string;
    /**
     * 体积（立方米）
     * @type {number}
     * @memberof ProductListSkuItem
     */
    cbm?: number;
    /**
     * 合单数量
     * @type {number}
     * @memberof ProductListSkuItem
     */
    productCount?: number;
    /**
     * 当前返回的条码数量（与 barcodes 一致）
     * @type {number}
     * @memberof ProductListSkuItem
     */
    barcodeCount?: number;
    /**
     * 启用状态：0-下架，1-上架
     * @type {number}
     * @memberof ProductListSkuItem
     */
    enable?: number;
    /**
     * Logo图片URL
     * @type {string}
     * @memberof ProductListSkuItem
     */
    logoImgUrl?: string;
    /**
     * 是否可编辑（SKU级修改始终为 true）
     * @type {boolean}
     * @memberof ProductListSkuItem
     */
    editable?: boolean;
    /**
     * 是否可下架（上架列表显示）
     * @type {boolean}
     * @memberof ProductListSkuItem
     */
    canOffShelf?: boolean;
    /**
     * 是否可上架（下架列表显示）
     * @type {boolean}
     * @memberof ProductListSkuItem
     */
    canOnShelf?: boolean;
    /**
     * 是否可删除（与上下架状态无关；SKU 曾在订单中出现过时为 false，与 DELETE /sku/batch 判定一致）
     * @type {boolean}
     * @memberof ProductListSkuItem
     */
    deletable?: boolean;
    /**
     * 
     * @type {Array<ProductListSkuProductItem>}
     * @memberof ProductListSkuItem
     */
    skuProducts?: Array<ProductListSkuProductItem>;
    /**
     * 批量上传数量（Excel「数量」列）
     * @type {number}
     * @memberof ProductListSkuItem
     */
    uploadQuantity?: number;
    /**
     * 原产地标识（Excel「原产地标识 Y/N」列）
     * @type {string}
     * @memberof ProductListSkuItem
     */
    originFlag?: string;
    /**
     * 有效期限（Excel「有效期限 YYYY/MM/DD」列）
     * @type {string}
     * @memberof ProductListSkuItem
     */
    expiryDate?: string;
    /**
     * 产地标作业方式（Excel「产地标作业方式 手动输入」列）
     * @type {string}
     * @memberof ProductListSkuItem
     */
    originJob?: string;
}

/**
 * Check if a given object implements the ProductListSkuItem interface.
 */
export function instanceOfProductListSkuItem(value: object): value is ProductListSkuItem {
    return true;
}

export function ProductListSkuItemFromJSON(json: any): ProductListSkuItem {
    return ProductListSkuItemFromJSONTyped(json, false);
}

export function ProductListSkuItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProductListSkuItem {
    if (json == null) {
        return json;
    }
    return {
        
        'skuId': json['skuId'] == null ? undefined : json['skuId'],
        'skuCode': json['skuCode'] == null ? undefined : json['skuCode'],
        'imageUrl': json['imageUrl'] == null ? undefined : json['imageUrl'],
        'barcodes': json['barcodes'] == null ? undefined : ((json['barcodes'] as Array<any>).map(ProductListBarcodeItemFromJSON)),
        'unitPrice': json['unitPrice'] == null ? undefined : json['unitPrice'],
        'wtKg': json['wtKg'] == null ? undefined : json['wtKg'],
        'packageSpec': json['packageSpec'] == null ? undefined : json['packageSpec'],
        'cbm': json['cbm'] == null ? undefined : json['cbm'],
        'productCount': json['productCount'] == null ? undefined : json['productCount'],
        'barcodeCount': json['barcodeCount'] == null ? undefined : json['barcodeCount'],
        'enable': json['enable'] == null ? undefined : json['enable'],
        'logoImgUrl': json['logoImgUrl'] == null ? undefined : json['logoImgUrl'],
        'editable': json['editable'] == null ? undefined : json['editable'],
        'canOffShelf': json['canOffShelf'] == null ? undefined : json['canOffShelf'],
        'canOnShelf': json['canOnShelf'] == null ? undefined : json['canOnShelf'],
        'deletable': json['deletable'] == null ? undefined : json['deletable'],
        'skuProducts': json['skuProducts'] == null ? undefined : ((json['skuProducts'] as Array<any>).map(ProductListSkuProductItemFromJSON)),
        'uploadQuantity': json['uploadQuantity'] == null ? undefined : json['uploadQuantity'],
        'originFlag': json['originFlag'] == null ? undefined : json['originFlag'],
        'expiryDate': json['expiryDate'] == null ? undefined : json['expiryDate'],
        'originJob': json['originJob'] == null ? undefined : json['originJob'],
    };
}

export function ProductListSkuItemToJSON(json: any): ProductListSkuItem {
    return ProductListSkuItemToJSONTyped(json, false);
}

export function ProductListSkuItemToJSONTyped(value?: ProductListSkuItem | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'skuId': value['skuId'],
        'skuCode': value['skuCode'],
        'imageUrl': value['imageUrl'],
        'barcodes': value['barcodes'] == null ? undefined : ((value['barcodes'] as Array<any>).map(ProductListBarcodeItemToJSON)),
        'unitPrice': value['unitPrice'],
        'wtKg': value['wtKg'],
        'packageSpec': value['packageSpec'],
        'cbm': value['cbm'],
        'productCount': value['productCount'],
        'barcodeCount': value['barcodeCount'],
        'enable': value['enable'],
        'logoImgUrl': value['logoImgUrl'],
        'editable': value['editable'],
        'canOffShelf': value['canOffShelf'],
        'canOnShelf': value['canOnShelf'],
        'deletable': value['deletable'],
        'skuProducts': value['skuProducts'] == null ? undefined : ((value['skuProducts'] as Array<any>).map(ProductListSkuProductItemToJSON)),
        'uploadQuantity': value['uploadQuantity'],
        'originFlag': value['originFlag'],
        'expiryDate': value['expiryDate'],
        'originJob': value['originJob'],
    };
}

